import { render, staticRenderFns } from "./DdCheckS.vue?vue&type=template&id=14072510&scoped=true&"
import script from "./DdCheckS.vue?vue&type=script&lang=js&"
export * from "./DdCheckS.vue?vue&type=script&lang=js&"
import style0 from "./DdCheckS.vue?vue&type=style&index=0&id=14072510&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14072510",
  null
  
)

export default component.exports